/**
 * Navigable table rows keep a click handler as a mouse convenience, but the real way in is a Link
 * in the first cell (keyboard, Cmd+click, new tab). This stops the row handler from navigating a
 * second time when the click landed on that link or on any other control in the row.
 *
 *   <tr onClick={rowClick(() => navigate(`/companies/${c.id}`))}>
 *     <td><Link className="cell-link" to={`/companies/${c.id}`}>{c.name}</Link></td>
 */
export const isInteractiveTarget = (event) =>
  !!event.target.closest('a, button, input, select, textarea, label, [role="button"]');

/** Runs the handler only for clicks on the row itself, never on a control inside it. */
export const rowClick = (handler) => (event) => {
  if (isInteractiveTarget(event)) return;
  // Leave text selection alone: dragging across a cell should not open the record
  if (window.getSelection && String(window.getSelection()).length > 0) return;
  handler(event);
};
